import {
    AmountPart,
    AvailabilityReportMode,
    AvailabilityReportStates,
    ResourceCategoryTypes,
    ServiceAvailabilityReportExtent,
    TimeUnitPeriod,
} from '@mews-commander/data-access';

export enum ReportMode {
    Date = 'Date',
    Interval = 'Interval',
    AvailabilityHeatmap = 'AvailabilityHeatmap',
    OccupancyHeatmap = 'OccupancyHeatmap',
}

export interface WithReportMode {
    reportMode: ReportMode;
}

export interface FilterValues {
    startUtc: string;
    endUtc: string;
    serviceIds: string[];
    resourceCategoryIds: string[] | null;
    resourceCategoryTypes: ResourceCategoryTypes;
    amountPart: AmountPart;
    partnerCompanyId: string | null;
    rateIds: string[] | null;
    rateMode?: AvailabilityReportMode;
    travelAgencyId: string | null;
    scope: string;
    timeUnitPeriod: TimeUnitPeriod;
    states: AvailabilityReportStates;
}

export enum NavigationDirection {
    Prev = 'Prev',
    Next = 'Next',
}

export type InitAvailabilityReportParams = FilterValues &
    WithReportMode & {
        extent?: ServiceAvailabilityReportExtent;
    };

export type FetchAvailabilityReportDataParams = Omit<InitAvailabilityReportParams, 'scope'>;
